import { render, staticRenderFns } from "./SExaminations.vue?vue&type=template&id=586deb1a&"
import script from "./SExaminations.vue?vue&type=script&lang=js&"
export * from "./SExaminations.vue?vue&type=script&lang=js&"
import style0 from "./SExaminations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports